import { useEffect, useRef, useState } from "react";

/**
 * 컨테이너의 실제 픽셀 너비를 관찰한다. SVG 차트는 창 크기에 따라 폭이 달라지므로
 * (브라우저에서는 창 리사이즈까지) RN 의 `onLayout` 대신 `ResizeObserver` 를 쓴다.
 */
export function useElementWidth<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      const next = entries[0]?.contentRect.width ?? 0;
      setWidth(Math.floor(next));
    });
    observer.observe(el);
    setWidth(Math.floor(el.getBoundingClientRect().width));

    return () => observer.disconnect();
  }, []);

  return [ref, width] as const;
}
